import {call,put,takeLeading} from 'redux-saga/effects';
import {actions,types} from '@src/store';
import apiStore from '@src/apis';
import { GetConfig, FetchLocate } from '@src/apis/Config';
import { getLogin } from './User';

function* configSaga(){
    yield takeLeading(types.config.GetConfig, getConfigData)
}

function* getConfigData(){
    let baseConfigs=false;
    try{
        const configuration=yield call( GetConfig );
        
        //set root api settings:
        const vendorData = configuration.vendorDetails ;


        apiStore.setBase( { 
            baseUrl: vendorData.baseUrl, 
            ...configuration.apiUtils 
        });
        const params = {
            vendorid: vendorData.vendorId,
            vendorkey: vendorData.vendorKey,
            devicetype:"WEB"
        }
        apiStore.addParams( params );

        //locate user:
        const country = yield call( FetchLocate );

        apiStore.addParams( { country } );

        configuration.country__ = country ; //story location in config data.

        yield put( actions.config.Success( configuration ) );
        baseConfigs=true;

        //auto log user:
        yield call( getLogin, { payload : {}, autoLogin: true } );

        yield put(actions.config.Loaded());
    }
    catch(err){
        Logger.log(err);
        if(baseConfigs)yield put(actions.config.Loaded());
    }
}

export default configSaga;